module.exports = __webpack_public_path__ + "static/media/speak_join.83cf9032.png";